import * as React from "react";
import { Leaf, BadgeDollarSign, MapPin, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const features = [{
  title: "+40% Booking Rate",
  description: "Visual psychology studies show that high-end AI-enhanced imagery directly correlates with increased guest confidence and booking frequency.",
  icon: Leaf,
  iconColor: "text-secondary",
  link: "/HomePage"
}, {
  title: "+25% RevPAR",
  description: "Properties with premium visual presentation command higher nightly rates, allowing you to maximize revenue per available room effortlessly.",
  icon: BadgeDollarSign,
  iconColor: "text-secondary",
  link: "/HomePage"
}, {
  title: "24h Delivery",
  description: "Our AI-driven workflow ensures your property is market-ready within a day, minimizing downtime and accelerating your return on investment.",
  icon: MapPin,
  iconColor: "text-secondary",
  link: "/HomePage"
}];
export default function TheRoiOfElegance() {
  return <section data-section-id="225002" id="the-roi-of-elegance" className="bg-primary text-primary-foreground py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-light tracking-widest text-secondary md:text-4xl lg:text-5xl uppercase">
            The ROI of Elegance
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg font-default text-muted-foreground/80">
            Invest in visual excellence. Our AI enhancement service isn't just an aesthetic choice—it's a strategic financial upgrade for your hospitality business.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <Link to={feature.link} className="absolute inset-0 z-10">
                <span className="sr-only">Learn more about {feature.title}</span>
              </Link>
              <Card className="flex h-full flex-col justify-between rounded-md border border-secondary/20 bg-card/5 transition-colors duration-500 group-hover:border-secondary/50">
                <div>
                  <CardHeader className="pb-4">
                    <feature.icon className={`mb-4 size-16 stroke-[1] ${feature.iconColor}`} aria-hidden="true" />
                    <CardTitle className="font-default text-2xl font-medium tracking-wide text-secondary">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base font-default text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex items-center text-sm font-bold uppercase tracking-widest text-secondary opacity-0 transition-all duration-500 group-hover:translate-x-2 group-hover:opacity-100">
                    Explore Impact <ArrowRight className="ml-2 size-4 stroke-[2]" />
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}